import { takeEvery, put } from 'redux-saga/effects'
import {
  updateUserPhoneNumber,
  updateUserTeamsSuccessForMicroactions,
  updateUserEmail,
} from 'store/entities/organizations/actions'
import { modal } from 'store/entities/modal/actions'
import RefreshCacheModal from 'app/domains/common/Modals/RefreshCacheModal/RefreshCacheModal'

export function* handleSaveOrgSuccess() {
  yield put(
    modal.show(RefreshCacheModal, {
      size: 'sm',
    })
  )
}

export default function* takeEverySaveOrganizationSuccess() {
  yield takeEvery(
    [
      updateUserPhoneNumber.success.toString(),
      updateUserTeamsSuccessForMicroactions,
      updateUserEmail.success.toString(),
    ],
    handleSaveOrgSuccess
  )
}
